export const wordList = [
    "Accordo",
    "Acero",
    "Acqua",
    "Aereo",
    "Africa",
    "Corda",
    "Anno",
    "Agente",
    "Ago",
    "Albergo",
    "Albero",
    "Alieno",
    "Cera",
    "Ape",
    "Base",
    "Alpi",
    "Alunno",
    "Amazon",
    "Ambasciata",
    "Ambulanza",
    "America",
    "Anatra",
    "Natale",
    "Anello",
    "Angelo",
    "Anima",
    "Antartide",
    "Aquila",
    "Arancia",
    "Arco",
    "Aria",
    "Australia",
    "Automobile",
    "Avorio",
    "Avvocato",
    "Azteco",
    "Bacca",
    "Balena",
    "Ballo",
    "Banco",
    "Banca",
    "Banda",
    "Bar",
    "Bastone",
    "Caccia",
    "Batteria",
    "Becchino",
    "Berlino",
    "Bermuda",
    "Berretto",
    "Bicchiere",
    "Blocco",
    "Bocca",
    "Bolletta",
    "Bomba",
    "Ombelico",
    "Bottiglia",
    "Bottone",
    "Botte",
    "Bozza",
    "Braccio",
    "Zoccolo",
    "Bronzo",
    "Bullone",
    "Caduta",
    "Calcio",
    "Calice",
    "Calzino",
    "Cambio",
    "Campana",
    "Pane",
    "Campo",
    "Canale",
    "Canada",
    "Cane",
    "Canguro",
    "Cannuccia",
    "Canna",
    "Casa",
    "Cassa",
    "Capo",
    "Capitale",
    "Cappuccio",
    "Carica",
    "Carota",
    "Chiodo",
    "Carta",
    "Casinò",
    "Cast",
    "Disco",
    "Catena",
    "Capelli",
    "Cavaliere",
    "Cavallo",
    "Cella",
    "Cellula",
    "Centauro",
    "Centro",
    "Cerchio",
    "Chiave",
    "Chiesa",
    "Ciclo",
    "Cina",
    "Cintura",
    "Cioccolato",
    "Club",
    "Coda",
    "Codice",
    "Collegamento",
    "Legno",
    "Collo",
    "Colombo",
    "Colonna",
    "Colpo",
    "Coltello",
    "Combattente",
    "Comparto",
    "Composto",
    "Posizione",
    "Concerto",
    "Conduttore",
    "Coniglio",
    "Consiglio",
    "Contrabbandiere",
    "Contratto",
    "Controllo",
    "Copertura",
    "Coperta",
    "Corno",
    "Corona",
    "Corte",
    "Corteccia",
    "Cortile",
    "Cotone",
    "Cravatta",
    "Croce",
    "Cucciolata",
    "Cuoco",
    "Uovo",
    "Cuore",
    "Sangue",
    "Dado",
    "Danza",
    "Volo",
    "Dante",
    "Data",
    "Dente",
    "Diamante",
    "Diavolo",
    "Dinosauro",
    "Documento",
    "Folletto",
    "Tasso",
    "Dottore",
    "Drago",
    "Egitto",
    "Fattura",
    "Libro",
    "Elicottero",
    "Erba",
    "Etichetta",
    "Europa",
    "Faccia",
    "Falange",
    "Falco",
    "Fantasma",
    "Fata",
    "Ferro",
    "Fiera",
    "Figura",
    "Fila",
    "Film",
    "Flauto",
    "Flusso",
    "Foca",
    "Forchetta",
    "Resistenza",
    "Foresta",
    "Foro",
    "Fortuna",
    "Forza",
    "Francia",
    "Frusta",
    "Metro",
    "Fumetto",
    "Fusto",
    "Fuoco",
    "Furgone",
    "Gancio",
    "Gas",
    "Gatto",
    "Gelato",
    "Genio",
    "Germania",
    "Ghiaccio",
    "Gigante",
    "Gioco",
    "Giorno",
    "Giove",
    "Giro",
    "Goccia",
    "Grado",
    "Grattacielo",
    "Grazia",
    "Isola",
    "Grecia",
    "Grillo",
    "Guardia",
    "Guarnizione",
    "Gru",
    "Riso",
    "Ritmo",
    "Guanto",
    "Guerra",
    "Himalaya",
    "Hollywood",
    "Tesoro",
    "Incantesimo",
    "Incontro",
    "Incidente",
    "Indice",
    "India",
    "Infermiera",
    "Inghilterra",
    "Insegnante",
    "Insetto",
    "Interruttore",
    "Jet",
    "Ketchup",
    "Kiwi",
    "Laboratorio",
    "Ladro",
    "Laser",
    "Lavello",
    "Moneta",
    "Legame",
    "Leone",
    "Letto",
    "Limone",
    "Limousine",
    "Linea",
    "Lira",
    "Londra",
    "Luce",
    "Macchina",
    "Piovra",
    "Lumaca",
    "Luna",
    "Malattia",
    "Mammut",
    "Mano",
    "Mantello",
    "Marmellata",
    "Marmo",
    "Marzo",
    "Mela",
    "Mercurio",
    "Messa",
    "Messico",
    "Microscopio",
    "Rospo",
    "Miele",
    "Milionario",
    "Miniera",
    "Missile",
    "Modello",
    "Montatura",
    "Mora",
    "Monte",
    "Morte",
    "Mosca",
    "Motore",
    "Muro",
    "Mossa",
    "Mutande",
    "Nano",
    "Nave",
    "Napoli",
    "Negozio",
    "Neve",
    "New York",
    "Ninja",
    "Noce",
    "Nota",
    "Notte",
    "Occhio",
    "Olimpo",
    "Olio",
    "Oliva",
    "Viola",
    "Ombra",
    "Onda",
    "Sacco",
    "Opera",
    "Svizzera",
    "Pera",
    "Organo",
    "Oro",
    "Orologio",
    "Orso",
    "Oscillazione",
    "Ospedale",
    "Padella",
    "Palla",
    "Palma",
    "Palo",
    "Asse",
    "Pantalone",
    "Arresto",
    "Paracadute",
    "Patata",
    "Parco",
    "Assassino",
    "Parte",
    "Partita",
    "Passaggio",
    "Passo",
    "Pasta",
    "Pechino",
    "Pecora",
    "Pesce",
    "Peso",
    "Pesca",
    "Pettirosso",
    "Tiro",
    "Petto",
    "Pianoforte",
    "Piatto",
    "Piazza",
    "Picco",
    "Piede",
    "Pietra",
    "Pilota",
    "Pin",
    "Pinocchio",
    "Pinguino",
    "Piombo",
    "Pipa",
    "Pipistrello",
    "Piramide",
    "Pirata",
    "Piscina",
    "Pistola",
    "Plastica",
    "Polizia",
    "Pollice",
    "Polpo",
    "Pollo",
    "Ponte",
    "Porta",
    "Porto",
    "Posta",
    "Pozzo",
    "Pranzo",
    "Primavera",
    "Verso",
    "Profilo",
    "Principessa",
    "Prosciutto",
    "Pulcino",
    "Punto",
    "Racchetta",
    "Radice",
    "Radio",
    "Raffreddore",
    "Ragazzo",
    "Raggio",
    "Ragno",
    "Rame",
    "Re",
    "Recinto",
    "Regina",
    "Registro",
    "Rete",
    "Riga",
    "Righello",
    "Lupo",
    "Rivoluzione",
    "Robot",
    "Roma",
    "Romanzo",
    "Cimice",
    "Rondella",
    "Rosa",
    "Lettera",
    "Roulette",
    "Ruota",
    "Rubinetto",
    "Satellite",
    "Saturno",
    "Turno",
    "Scala",
    "Scarpa",
    "Scatola",
    "Schermo",
    "Scheda",
    "Schiena",
    "Scia",
    "Scienziato",
    "Sciopero",
    "Scogliera",
    "Scorpione",
    "Corso",
    "Area",
    "Scuola",
    "Sedia",
    "Seno",
    "Serratura",
    "Server",
    "Spaghetto",
    "Shakespeare",
    "Soldato",
    "Soldo",
    "Spazio",
    "Squadra",
    "Spazzola",
    "Spirito",
    "Spia",
    "Spiaggia",
    "Squalo",
    "Stadio",
    "Staff",
    "Stato",
    "Baffo",
    "Stella",
    "Sterlina",
    "Lingua",
    "Stivale",
    "Strega",
    "Stringa",
    "Subacqueo",
    "Suono",
    "Supereroe",
    "Tablet",
    "Tacchino",
    "Talpa",
    "Tavola",
    "Tazza",
    "Teatro",
    "Magia",
    "Telescopio",
    "Coppa",
    "Tempio",
    "Tempo",
    "Maiale",
    "Terra",
    "Testa",
    "Titolo",
    "Tokyo",
    "Tono",
    "Topo",
    "Torcia",
    "Torre",
    "Torta",
    "Traccia",
    "Amo",
    "Trama",
    "Trapano",
    "Treno",
    "Lampo",
    "Triangolo",
    "Tromba",
    "Tronco",
    "Tubo",
    "Unicorno",
    "Veleno",
    "Vento",
    "Ventola",
    "Verde",
    "Verme",
    "Vestito",
    "Veterinario",
    "Viaggio",
    "Vino",
    "Vita",
    "Vite",
    "Vitello",
    "Vuoto",
    "Washington",
    "Web",
    "Zecca",
    "Zucca",
    "Zucchero"
  ];

export const spymaster = ["A", "A", "A", "A", "A", "A", "A", "A", "A", "B", "B", "B", "B", "B", "B", "B", "B", "N", "N", "N", "N", "N", "N", "N", "X"];